import RowCenter from './RowCenter';

export default RowCenter;
